import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { Session } from "@webapp/sessions/models/sessions.model";

@Component({
  selector: "single-goal-selector-session-row",
  templateUrl: "./single-goal-selector-session-row.component.html",
  styleUrls: ["./single-goal-selector-session-row.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleGoalSelectorSessionRowComponent {
  @Input() public session: Session;
  @Input() public enableOkrSelectionOnly: boolean;

  @Output()
  public readonly sessionSelected = new EventEmitter();

  public onSessionSelected(selectedSession: Session): void {
    this.sessionSelected.emit(selectedSession);
  }
}
